import { CollabLocation, CollabLocationsData } from "@contracts/collabLocations";
import { shrpaApi } from "./axios";

interface CollabLocationGetResponse {
  locationsInAdventures: string[];
  locationData: CollabLocationsData;
}

interface SaveReorderedListPayload {
  itemIdToReorder: string;
  newIndex: number;
}

export default {
  async fetchCollabLocationsData(collabInputId: string, creatorId: string, customerId: string): Promise<CollabLocationGetResponse> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations`;
    const { data } = await shrpaApi.get<CollabLocationGetResponse>(uri);
    return data;
  },

  async addOrRemoveLocationMedia(collabLocationsData: CollabLocationsData, mediaIdsToRemove: string[], customerId: string, collabInputId: string, creatorId: string): Promise<CollabLocationsData> {
    const payload = {
      mediaAdds: collabLocationsData,
      mediaIdsToRemove: mediaIdsToRemove,
    };
    const uri = `collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations/media`;
    const { data } = await shrpaApi.put<CollabLocationsData>(uri, payload);
    return data;
  },

  async createLocation(customerId: string, collabInputId: string, creatorId: string, howManyToCreate = 1): Promise<CollabLocationsData> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations?howManyToCreate=${howManyToCreate}`;

    const { data } = await shrpaApi.post<CollabLocationsData>(uri);

    return data;
  },

  async updateLocation(customerId: string, collabInputId: string, creatorId: string, collabLocation: CollabLocation): Promise<CollabLocationsData> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations/${collabLocation.id}`;
    const payload = JSON.stringify(collabLocation);
    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<CollabLocationsData>(uri, payload, config);

    return data;
  },

  async deleteLocation(customerId: string, collabInputId: string, creatorId: string, collabLocationId: string): Promise<CollabLocationsData> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations/${collabLocationId}`;

    const { data } = await shrpaApi.delete<CollabLocationsData>(uri);

    return data;
  },

  async saveReorderedList(customerId: string, collabInputId: string, creatorId: string, itemId: string, newIndex: number): Promise<CollabLocationsData> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations/reorder`;

    const payload = { itemIdToReorder: itemId, newIndex } as SaveReorderedListPayload;
    const serializedPayload = JSON.stringify(payload);

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<CollabLocationsData>(uri, serializedPayload, config);

    return data;
  },

  async saveAdditionalNotes(customerId: string, collabInputId: string, creatorId: string, notes: string): Promise<CollabLocationsData> {
    const uri = `/collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/locations/additional-notes`;
    const payload = JSON.stringify({ notes });
    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<CollabLocationsData>(uri, payload, config);

    return data;
  },
};
